module.exports = "./img/e7c355d617d20966f9c4ec711b2f872d.jpg";